// Пользовательские GeoJSON-слои: файл, перетащенный на карту, рендерится клиентски
// (mapbox geojson-source), без бэкенда. См. utils/userGeoJson.js и Map.jsx (handleFileDrop).
import { defineMessage } from '@lingui/macro';

// Предел размера файла. Mapbox GL держит geojson-источник целиком в памяти,
// на бо́льших файлах вкладка начинает ощутимо тормозить.
export const USER_GEOJSON_MAX_BYTES = 25 * 1024 * 1024;

// Расширения, которые принимаем при drag&drop.
export const USER_GEOJSON_EXTENSIONS = [ '.geojson', '.json' ];

// Единый цвет всех пользовательских слоёв: заливка с прозрачностью 50 %, обводка сплошная.
export const USER_LAYER_COLOR = '#8E44FF';
export const USER_LAYER_FILL_OPACITY = 0.5;

// Группа в сайдбаре, в которую попадают все загруженные слои.
export const USER_LAYERS_GROUP_LABEL = defineMessage({ message: 'Пользовательские слои' });
export const USER_LAYERS_GROUP_ID = 'user-geojson';

// Префикс id слоя на карте — отделяет пользовательские слои от статических
// (имя файла может совпасть с названием существующего слоя).
export const USER_LAYER_PREFIX = 'user:';

export const isUserLayerId = id => typeof id === 'string' && id.startsWith(USER_LAYER_PREFIX);
